import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../../state/fetch-dux';

// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
const shuffle = source => {
  const array = Object.assign([], source);
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};

class StillThirsty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stillThirstyProducts: []
    };
  }
  componentDidMount() {
    this.props.getShopProducts();
  }
  componentDidUpdate(prevProps) {
    const { result, ProductID } = this.props;
    const { stillThirstyProducts } = this.state;

    if (stillThirstyProducts && stillThirstyProducts.length) return;

    if (!result || !result.length) return;

    const products = (result || [])
      .filter(({ isStillThirsty }) => isStillThirsty)
      .filter(({ ProductID: ID }) => ID !== ProductID);

    if (products.length === 0) return;

    const shuffled = shuffle(products);

    const sliced = (shuffled || []).slice(0, 3);

    this.setState({ stillThirstyProducts: sliced });
  }
  render() {
    const { stillThirstyProducts, deviceType } = this.state;

    const breakpoints = {
      desktop: {
        breakpoint: { max: 3000, min: 999 },
        items: 3,
        paritialVisibilityGutter: 40
      },
      tablet: {
        breakpoint: { max: 999, min: 768 },
        items: 2,
        paritialVisibilityGutter: 40
      },
      desktop: {
        breakpoint: { max: 768, min: 0 },
        items: 1,
        paritialVisibilityGutter: 60
      }
    };

    return (
      <section className="product-grid swiper-holder">
        <div className="swiper-hider" />

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <h2 className="section">Still Thirsty?</h2>

              <div className="row noswiper thirsty-list">

                {(stillThirstyProducts || []).map(({
                  Slug,
                  images,
                  Name
                }, index) => {
                  const { shopGridImage } = images || {};
                  const image = shopGridImage || {};
                  const { href } = image || {};
                  return (
                    <div className="col-md-4 col-sm-6" key={index}>
                      <div className="item">
                        <div className="product-details thirsty-details">
                          <Link to={`/shop/p/${Slug}/`}>
                            <span
                              className="product-detail-image"
                              style={{ backgroundImage: `url(${href})` }}
                            />
                            <span className="product-name">{Name}</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}

              </div>
            </div>
          </div>
        </div>

        <Carousel
          partialVisbile
          itemClass="product-item"
          responsive={breakpoints}
          className="thirsty-carousel"
        >
          {(stillThirstyProducts || []).slice(0, 6).map(({
            Slug,
            images,
            Name
          }, index) => {
            const { shopGridImage } = images || {};
            const image = shopGridImage || {};
            const { href } = image || {};
            return (
              <div className="item" key={index}>
                <div className="product-details thirsty-details">
                  <Link to={`/shop/p/${Slug}/`}>
                    <span
                      className="product-detail-image"
                      style={{ backgroundImage: `url(${href})` }}
                    />
                    <span className="product-name">{Name}</span>
                  </Link>
                </div>
              </div>
            );
          })}
        </Carousel>

      </section>
    );
  }
}

const mapState = state => {
  const {
    error,
    result,
    inProgress
  } = state.getShopProducts.toJS();
  return {
    result
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      getShopProducts: fetchDux.getShopProducts.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(StillThirsty);
